import { createSlice } from '@reduxjs/toolkit';

export const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    loading: true,
    contact: [],
    error: null,
    sort: 'extension',
    // selfPresence: 'open'
  },
  reducers: {
    setContact: (state, action) => {
      state.loading = false;
      state.contact = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    removeContact: (state, action) => {
      state.contact = state.contact.filter(
        contact => contact.contact_id !== action.payload
      );
    },
  },
});

export const { setContact, setSort, removeContact } = contactSlice.actions;

//Selectors
export const selectContact = (state) => state.contact;
export default contactSlice.reducer;